import { TeamInfoPayload } from 'Shared/types/TeamInfo.types';
import PiInstance from './Pi.instance';

export const getUser = ({ companyGuid, userGuid }: { companyGuid: string; userGuid: string }) =>
  PiInstance.instance.get(`/perform/api/v5/companies/${companyGuid}/person/details/${userGuid}`);

export const createBehavioralAssessment = ({ companyGuid, payload }: { companyGuid: string; payload: any }) =>
  PiInstance.instance.post(`/perform/api/v5/companies/${companyGuid}/behavioralassessment/employee`, payload);

export const getTeamInfo = (payload: TeamInfoPayload) => PiInstance.instance.post('/perform/api/v5/teamInfo', payload);

export type CreateNotetakerSummaryFeedbackParams = {
  userGuid: string;
  responseId?: string;
  feedbackData: {
    summaryId: string;
    isPositiveFeedback: boolean;
    additionalFeedback?: string;
    selectedOptions?: { optionText: string; isSelected: boolean }[];
  };
};

export const createNotetakerSummaryFeedback = (payload: CreateNotetakerSummaryFeedbackParams) =>
  PiInstance.instance.post('/perform/api/v5/feedback/notetaker-summary', payload);

export type createPrivateSelfRemindersFeedbackParams = {
  userGuid: string;
  feedbackData: {
    openFeedback?: string;
    reminders?: { text: string; doesResonate: boolean }[];
  };
};

export const createPrivateSelfRemindersFeedback = (payload: createPrivateSelfRemindersFeedbackParams) =>
  PiInstance.instance.post('/perform/api/v5/feedback/private-self-reminders', payload);
